import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class INDRAURLService {

	escapeArray: {character: string, escapeCode: string}[] = [
		{character: ' ', escapeCode: '%20'},
		{character: ';', escapeCode: '%3B'}
	];

	INDRA_getEscapedUrl(url: string): string {
		if (url) {
			this.escapeArray.forEach(escapeItem => {
				url = url.replace(escapeItem.character, escapeItem.escapeCode);
			});
		}
		return url;
	}

	INDRA_updateMaskedField(url: string, mask: string, replacementValue: string): string {
		if (url && url.includes(mask)) {
			url = url.replace(mask, replacementValue);
		}
		return url;
	}

	INDRA_getUrlParams(name, url) {
		if (!url) url = location.href;
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(url);
		return results == null ? null : results[1];
	}

	INDRA_getFilteredParams(queryParams: Object) {
		return Object.keys(queryParams)
		.reduce((obj, key) => {
			obj[key] = queryParams[key];
			return obj;
		}, {});

	}
}
